import { reduxKey } from './constants';
export var getEditorSlice = function (state, editorId) {
    return (state[reduxKey] && state[reduxKey][editorId]) || {};
};
export var isBusy = function (state, editorId) { var _a; return (_a = getEditorSlice(state, editorId)['isBusy']) !== null && _a !== void 0 ? _a : false; };
export var getPublishResult = function (state, editorId) {
    return getEditorSlice(state, editorId)['publishResult'];
};
export var isError = function (state, editorId) {
    return getEditorSlice(state, editorId)['isError'];
};
export var getErrorMsg = function (state, editorId) {
    return getEditorSlice(state, editorId)['errorMsg'];
};
export var getIsFocusRequested = function (state, editorId, defaultValue) {
    if (defaultValue === void 0) { defaultValue = false; }
    var focus = getEditorSlice(state, editorId)['isFocusRequested'];
    if (focus === undefined) {
        return defaultValue;
    }
    return focus;
};
//# sourceMappingURL=selectors.js.map